import { applyUpdate, dismissUpdate, useNeedRefresh } from '../../lib/swUpdate'
import './update.css'
import { IconoCerrar } from '../common'

// Aviso de versión nueva. Aparece abajo al centro cuando el service worker
// descargó una versión y está esperando. No bloquea: se puede posponer y seguir
// trabajando; la nueva entra en la siguiente carga de todos modos.
export function UpdateToast() {
  const needRefresh = useNeedRefresh()
  if (!needRefresh) return null

  return (
    <div className="upd-toast" role="status" aria-live="polite">
      <span className="upd-dot" aria-hidden="true" />
      <span className="upd-text">Hay una versión nueva de camp</span>
      <button type="button" className="upd-btn" onClick={applyUpdate}>
        Recargar
      </button>
      <button type="button" className="upd-x" onClick={dismissUpdate} aria-label="Ahora no">
        <IconoCerrar />
      </button>
    </div>
  )
}
